import { Avatar } from '@change/ds-core-ui/Avatar';
import { Badge } from '@change/ds-core-ui/Badge';
import { CheckIcon } from '@change/ds-icons/CheckIcon';

type VerifiedAvatarProps = {
	avatarUrl: string;
};

export const VerifiedAvatar: React.FC<VerifiedAvatarProps> = ({ avatarUrl }) => {
	return (
		<div className="w-6">
			<div className="relative">
				<Avatar src={avatarUrl || ''} alt="" className="border-stroke-weaker w-6 border" />
				<Badge
					iconOnly
					leadingIcon={<CheckIcon className="h-2 w-3" />}
					className="bg-fill-success-strong absolute right-[-4px] bottom-[-2px] z-10 h-3 w-3 min-w-[unset]"
				/>
			</div>
		</div>
	);
};
